export enum CategoryNames
{
    Middleware = 'middleware',
    Database = 'database',
    Security = 'security'
}